import React from 'react';
import { Link } from 'gatsby';
import classnames from 'classnames';
import Icon from 'components/UI/Icon';
import * as styles from './styles.module.scss';

const NewsCardArrow = ({ data }) => {
  return (
    <Link to={'#'} className={classnames(styles.card)}>
      <div>
        <div className={classnames(styles.imgWrap)}>
          {data.image && <img src={data.image} className={styles.img} alt="" />}
        </div>
        <div>
          <h3 className={classnames(styles.title, 'cr-h3')}>
            {data.title && data.title}
          </h3>

          <div className={classnames(styles.textInner)}>
            <p className={classnames(styles.description, 'cr-lead')}>
              {data.description && data.description}
            </p>
            <i>
              <Icon name="corner-arrow-bg" />
            </i>
          </div>
        </div>
      </div>
    </Link>
  );
};

export default NewsCardArrow;
